import type { TFunction } from 'i18next';
import { CREDITS_ERROR } from '../constants/credits';

/** What the person is told when the server refuses a coupon, by its error code. */
export const couponErrorTexts = (t: TFunction): Record<string, string> => ({
  [CREDITS_ERROR.couponNotFound]: t('COUPON_NOT_FOUND', 'This coupon code is not valid.'),
  [CREDITS_ERROR.couponNotStarted]: t('COUPON_NOT_STARTED', 'This coupon is not valid yet.'),
  [CREDITS_ERROR.couponExpired]: t('COUPON_EXPIRED', 'This coupon has expired.'),
  [CREDITS_ERROR.couponNotApplicable]: t('COUPON_NOT_APPLICABLE', 'This coupon does not apply to this amount.'),
  [CREDITS_ERROR.couponAlreadyUsed]: t('COUPON_ALREADY_USED', 'Your organization has already used this coupon.'),
  [CREDITS_ERROR.couponExhausted]: t('COUPON_EXHAUSTED', 'This coupon has been used up.'),
  [CREDITS_ERROR.couponInUse]: t(
    'COUPON_IN_USE',
    'Another top-up of your organization is using this coupon right now.'
  ),
  [CREDITS_ERROR.payableBelowMinimum]: t(
    'PAYABLE_BELOW_MINIMUM',
    'The price after the coupon is below the minimum payment. Choose a larger amount.'
  ),
});
